import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/aKozlekedesiAnomaliakFeloldasa.png";
import asset6 from "../assets/media/images/asset6.png";
import back_btn from "../assets/media/newicons/back.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import forward_btn from "../assets/media/newicons/forward.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import bild from "../assets/media/images/ProgramImages/KozlekedesiAnomaliak.jpg";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class KozlekedesiAnomaliak extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


	render() {
		const anchors = ["program1", "program2", "program3"];
		let bodywrapperHeight = parseInt(window.outerWidth*0.8 + 100);
		let bodywrapperHeightText = bodywrapperHeight + "px";
    return (
			<>
			<MDBContainer fluid className="fluid-container">
				<div className="d-none d-lg-block">
					<div className={styles.bodywrapper7}>
						<BackComponent text={"PenzugyiForrasok"} text2={"A pénzügyi forrásokról"} program={"program7"}/>
						<img className="bild" src={bild}></img>
						<MDBContainer fluid className="program-container-programok">
							<Scrollbar
												id="scrollbar"
												style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
												maximalThumbYSize = {50}
												noScrollX = {true}
							>
								<MDBContainer fluid className="section" id="program">
									<div className={styles.bodywrapper3}>
										<MDBRow  center className="program-text-row">
										</MDBRow>
										<MDBRow  center className="program-text-row">
										<p className="jelenleg-is-ont-kepv">Lépjünk egyet előre! – a közlekedési anomáliák feloldása</p>
										<p className="a-megyei-kozgyulesbe">Tatabányán kiemelten fontos a vasútállomás felújítása.
										A 12 éve tartó ígérgetés helyett az épület rekonstrukciójával biztosítjuk az akadálymentes közlekedést,
										a városi piac működését, valamint Dózsakert és Újváros gyalogos és kerékpáros összeköttetését!
										Megszüntetjük a vasútállomásnál a parkolási anomáliákat!</p>
										<p className="a-megyei-kozgyulesbe">A térség egyik problémája, hogy az utóbbi évtizedek igen rohamos iparosodását nem követte
										a logisztikához leginkább szükséges szállítási feltételek fejlesztése. Lakossági szempontból
										ebben a legnagyobb gond az elkerülő utak hiánya: Oroszlánnyal és Környével ellentétben
										Tatán és Tatabányán még nem teljesen élhetetlen a város, a forgalom „csak” egy része zúdul ide. </p>
										</MDBRow>
										<MDBRow  center className="program-text-row-end">
										<p className="a-megyei-kozgyulesbe">Ugyanakkor Tatabányán a Budapest irányába közlekedők a városon keresztül
										csatlakoznak az M1-es útra, ezzel jelentősen terhelve Bánhida és Óváros útjait és zavarva lakosainak nyugalmát.
										Vértesszőlős átmenő főútja a végletekig terhelt: romlik az út felülete, az ott élők ingatlanjai értéküket vesztik.
										A forgalom csökkentését segítő Tatabányát-Vértesszőlőst-Tatát elkerülő utak megépültéig ingyenessé tesszük a
										Tatabánya-Tata közti autópályaszakaszt!</p>
										<p className="a-megyei-kozgyulesbe">Tata északi (nyugati) elkerülő útjának megépítése is sürgető, hogy a Duna-vonalra menő
										forgalom ne a városon át haladjon, illetve, hogy a kamion forgalom csökkenjen, a belterületi tranzit utak zsúfoltsága megszűnjön.
										Forrást biztosítunk Tata elkerülő útjára!</p>
										<p className="a-megyei-kozgyulesbe">Körforgalmak építésével tesszük biztonságosabbá, ütemesebbé a belterületi közlekedést:
										Tatán a Baji úton, Tatabányán az Eszterházy utca Tatai utca csomópontban és az
										Árpád-Vágóhíd-Mészáros utca kereszteződésében! Zajvédő falakkal is csökkentjük
										a megnövekedett forgalom okozta kellemetlenségeket!</p>
										<p className="a-megyei-kozgyulesbe">Szárligeten az autópályalehajtó miatt szükséges az utak fejlesztése.
										Biztosítjuk az autópálya lehajtó és az 1-es út összeköttetését és a Gerecse oldali utcáinak burkolását!</p>
										<p className="a-megyei-kozgyulesbe">Szerethetővé tesszük a tömegközlekedést! Komplexen – tehát a településeket
										nem egymástól mesterségesen elválasztva – kezeljük az iskolabuszokat,
										az ipari parkos buszokat, a helyi és helyközi járatokat!</p>
										</MDBRow>

									</div>
							</MDBContainer>

						</Scrollbar>
					</MDBContainer>

					<div className="fixed-bottom d-none d-lg-block">
					<div className="gradient"/>
						<Footer/>
					</div>
				</div>
				</div>
			</MDBContainer>

			<div className="d-block d-lg-none">
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper4}>
						<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"PenzugyiForrasok"} program={"program7"}/>
						<img className="bild2" src={bild}></img>
					</div>
					<div className={styles.bodywrapper3}>
						<img className="asset5-respo" src={asset5}></img>
						<MDBRow  center className="program-text-row m-0 px-3">
						<p className="jelenleg-is-ont-kepv">Lépjünk egyet előre! – a közlekedési anomáliák feloldása</p>
						<p className="a-megyei-kozgyulesbe">Tatabányán kiemelten fontos a vasútállomás felújítása.
						A 12 éve tartó ígérgetés helyett az épület rekonstrukciójával biztosítjuk az akadálymentes közlekedést,
						a városi piac működését, valamint Dózsakert és Újváros gyalogos és kerékpáros összeköttetését!
						Megszüntetjük a vasútállomásnál a parkolási anomáliákat!</p>
						<p className="a-megyei-kozgyulesbe">A térség egyik problémája, hogy az utóbbi évtizedek igen rohamos iparosodását nem követte
						a logisztikához leginkább szükséges szállítási feltételek fejlesztése. Lakossági szempontból
						ebben a legnagyobb gond az elkerülő utak hiánya: Oroszlánnyal és Környével ellentétben
						Tatán és Tatabányán még nem teljesen élhetetlen a város, a forgalom „csak” egy része zúdul ide. </p>
						</MDBRow>
						<MDBRow  center className="program-text-row-end m-0 px-3">
						<p className="a-megyei-kozgyulesbe">Ugyanakkor Tatabányán a Budapest irányába közlekedők a városon keresztül
						csatlakoznak az M1-es útra, ezzel jelentősen terhelve Bánhida és Óváros útjait és zavarva lakosainak nyugalmát.
						Vértesszőlős átmenő főútja a végletekig terhelt: romlik az út felülete, az ott élők ingatlanjai értéküket vesztik.
						A forgalom csökkentését segítő Tatabányát-Vértesszőlőst-Tatát elkerülő utak megépültéig ingyenessé tesszük a
						Tatabánya-Tata közti autópályaszakaszt!</p>
						<p className="a-megyei-kozgyulesbe">Tata északi (nyugati) elkerülő útjának megépítése is sürgető, hogy a Duna-vonalra menő
						forgalom ne a városon át haladjon, illetve, hogy a kamion forgalom csökkenjen, a belterületi tranzit utak zsúfoltsága megszűnjön.
						Forrást biztosítunk Tata elkerülő útjára!</p>
						<p className="a-megyei-kozgyulesbe">Körforgalmak építésével tesszük biztonságosabbá, ütemesebbé a belterületi közlekedést:
						Tatán a Baji úton, Tatabányán az Eszterházy utca Tatai utca csomópontban és az
						Árpád-Vágóhíd-Mészáros utca kereszteződésében! Zajvédő falakkal is csökkentjük
						a megnövekedett forgalom okozta kellemetlenségeket!</p>
						<p className="a-megyei-kozgyulesbe">Szárligeten az autópályalehajtó miatt szükséges az utak fejlesztése.
						Biztosítjuk az autópálya lehajtó és az 1-es út összeköttetését és a Gerecse oldali utcáinak burkolását!</p>
						<p className="a-megyei-kozgyulesbe">Szerethetővé tesszük a tömegközlekedést! Komplexen – tehát a településeket
						nem egymástól mesterségesen elválasztva – kezeljük az iskolabuszokat,
						az ipari parkos buszokat, a helyi és helyközi járatokat!</p>
						</MDBRow>
					</div>
				</MDBContainer>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper5}>
						<FooterResponziv/>
					</div>
				</MDBContainer>
			</div>
      </>
    );
  }
}
export default  KozlekedesiAnomaliak;
